module.exports = __webpack_public_path__ + "img/supervisor_account.5698815a.svg";